import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from '@env/environment';
import { UsuariosService } from '@services/usuarios/usuarios.service';
import { ToolsService } from '@services/varios/tools.service';
import { UsuarioData } from 'src/app/common/interfaces/user-login.interface';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx-js-style';

@Component({
  selector: 'app-carga-masiva',
  templateUrl: './carga-masiva.component.html',
  styleUrls: ['./carga-masiva.component.scss']
})


export class CargaMasivaComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<CargaMasivaComponent>,
    private readonly toolsService: ToolsService,
    private readonly usuariosService: UsuariosService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  cargaRealizada: boolean = false;

  subirPlantilla() {
    let usuarios: UsuarioData[] = [];
    let results: any = [];
    let tieneErrores: boolean = false;

    Swal.fire({
      input: 'file',
      inputAttributes: {
        accept:
          'application/vnd.ms-excel.sheet.macroEnabled.12',
      },
      title: 'Subir Archivo Excel',
      text: 'Edite y suba el archivo generado en el paso anterior',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#e23234',
      cancelButtonColor: '#7f7f7f',
      showLoaderOnConfirm: true,
      preConfirm: async (file: any) => {
        if (!file) return;
        else {
          const arrayBuffer = await this.readAsArrayBuffer(file);
          const workbook = XLSX.read(arrayBuffer, {
            type: 'array', cellStyles: true, cellFormula: false, raw: true, sheetStubs: true
          });

          let cusProps: any = workbook.Custprops;
          let objStr = JSON.stringify(cusProps); 
          let obj = JSON.parse(objStr);        
          let metodoObj = obj["Metodo"];
          let ambienteObj = obj["Ambiente"];
          let sistemaObj = obj["Sistema"];
          let metodo: boolean = metodoObj.toString() == 'VBA';
          let ambiente: boolean = ambienteObj.toString() == 'PROD';
          let sistema: string = sistemaObj.toString();

          if (sistema != environment.idSistema) {
            let resu: { name: string; message?: string; } = { name: 'Archivo', message: 'PLantilla generada no corresponde al sistema.' };
            results.push(resu);
            tieneErrores = true;
          }

          if (!metodo) {
            let resu: { name: string; message?: string; } = { name: 'Archivo', message: 'Plantilla no ha sido editada, o fue editada sin las Macros de Excel activadas.' };
            results.push(resu);
            tieneErrores = true;
          }

          if (ambiente != environment.production) {
            tieneErrores = true;
            if (environment.production) {
              let resu: { name: string; message?: string; } = { name: 'Archivo', message: 'Esta subiendo una plantilla generada para ambiente QA en PRODUCCIÓN.' };
              results.push(resu);
            } else {
              let resu: { name: string; message?: string; } = { name: 'Archivo', message: 'Esta subiendo una plantilla generada para ambiente PRODUCCIÓN en QA.' };
              results.push(resu);
            }
          }

          const wsname = workbook.SheetNames[0];
          const worksheet: XLSX.WorkSheet = workbook.Sheets[wsname];
          let rangoStr: string = worksheet['!ref'] == undefined? "A1:A1" : worksheet['!ref'].toString();
          const range = XLSX.utils.decode_range(rangoStr);

          if (range.e.r == 0) {
            let resu: { name: string; message?: string; } = { name: 'Archivo', message: 'Debe generar la plantilla con al menos un rut.' };
            results.push(resu);
            tieneErrores = true;
          }

          if (!tieneErrores) {
            for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum++) {
              for (let colNum = range.s.c; colNum <= range.e.c; colNum++) {
                const cellAddress = { r: rowNum, c: colNum };
                const cellRef = XLSX.utils.encode_cell(cellAddress);
                const cell = worksheet[cellRef];
                if (cell && cell.s && cell.s.fgColor) {
                  const fgColor = cell.s.fgColor.rgb;
                  if (fgColor === 'FF0000') {
                    tieneErrores = true;
                    break;
                  }
                }
              }
              if (tieneErrores) {
                let resu: { name: string; message?: string; } = { name: 'Archivo', message: 'Plantilla tiene celdas en rojo que debe solucionar antes.' };
                results.push(resu);
                break;
              }
            }
          }

          if (!tieneErrores) {
            let data: any[] = XLSX.utils.sheet_to_json(worksheet);
            const propiedades = Object.keys(data[0]).join(';');

            if (propiedades.includes('id_usuario') && propiedades.includes('id_perfil')) {

              data.forEach((element) => {

                let usuario: UsuarioData = {} as UsuarioData;
                
                usuario.idUsuario = element.id_usuario;
                usuario.run = Number(element.rut.toString().split('-')[0]);
                usuario.dv = element.rut.toString().split('-')[1];
                usuario.nombres = element.nombres;
                usuario.apellidoPaterno = element.apellido_paterno;
                usuario.apellidoMaterno = element.apellido_materno;
                usuario.correoCorporativo = element.correo_corporativo;
                usuario.correoPersonal = element.correo_personal;
                usuario.nombrePerfil = element.nombre_perfil;
                usuario.idPerfil = element.id_perfil;
                usuario.nombreUsuario = element.nombre_usuario;
                usuario.claveUsuario = element.clave;
                usuario.region = element.direccion_regional_numero == 0 ? 'REGIÓN METROPOLITANA' : element.direccion_regional;
                usuario.direccionRegional = element.direccion_regional;
                usuario.direccionRegionalNumero = element.direccion_regional_numero;
                usuario.comuna = element.comuna;
                usuario.tipoUnidad = element.tipo_unidad;
                usuario.cargo = element.cargo;
                usuario.unidad = element.unidad;
                usuario.corrUnidadGesdep = element.corr_unidad_gesdep;
                usuario.codigoUnidadGesdep = element.codigo_unidad_gesdep;
                usuario.estadoUsuBool = element.estado == 'ACTIVO';
                usuario.estadoUsuario = element.estado;
                usuario.sexo = element.sexo;
                usuario.fechaNacimiento = element.fecha_nacimiento;

                usuario.idSistema = environment.idSistema;
                usuario.usarSso = environment.authorizer.usarSso;
                usuario.apiKey = environment.authorizer.apikeysso;
                usuario.clientID = environment.authorizer.clientId;

                usuarios.push(usuario);
              });
            } else {
              let resu: { name: string; message?: string; } = { name: 'Archivo', message: 'Plantilla no contiene información necesaria ó la carga no fue generada por sistema.' };
              results.push(resu);
              tieneErrores = true;
            }
          }
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result: { isConfirmed: any }) => {
      if (result.isConfirmed) {
        if (tieneErrores) {
          Swal.fire({
            title: 'Error en archivo',
            html: this.generateSummary(results),
            icon: 'info',
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#e23234',
            customClass: { htmlContainer : 'sweet-alert'},
          });

          results.length = 0;          
          return;

        } else {
          await Swal.fire({
            title: 'Iniciar carga de usuarios',
            text: 'Haz clic en "Iniciar" para ejecutar la carga, esta operación podria demorar varios minutos! NO cierre NI recargue la página.',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Iniciar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#e23234',
            cancelButtonColor: '#7f7f7f',
          }).then(async (result2: { isConfirmed: any }) => {
            if (result2.isConfirmed) {
              await Swal.fire({
                title: 'Ejecutando carga...',
                text: 'Por favor, espera.',
                icon: 'info',
                allowOutsideClick: false,
                showConfirmButton: false,
                confirmButtonColor: '#e23234',
                didOpen: async () => {
                  Swal.showLoading(null);

                  this.cargaRealizada = true;

                  for (let index = 0; index < usuarios.length; index++) {
                    const element = usuarios[index];

                    Swal.update({
                      title: 'Ejecutando carga...',
                      text: `Fila: ${index + 1} de ${usuarios.length}: ${element.run + '-' + element.dv}`,
                    });

                    Swal.showLoading(null);
                    
                    let res: string = await this.usuariosService.cargarUsuarioService(element)
                    if (res != '') {
                      let resu: { name: string; message?: string; } = { name: element.run + '-' + element.dv, message: res };
                      results.push(resu);
                    }
                  }
                
                  Swal.close();
                },
              });
              
              let resu: { name: string; message?: string; } = { name: 'Resumen', message: 'Procesados : ' + usuarios.length + ' Advertencias: ' + results.length };
              results.splice(0, 0, resu);
              
              Swal.fire({
                title: 'Resumen de carga',
                html: this.generateSummary(results),
                icon: 'info',
                confirmButtonText: 'Aceptar',
                confirmButtonColor: '#e23234',
                customClass: { htmlContainer : 'sweet-alert'},
              });
            }
          });
        }
      }
    });
  }
  
  async generarPLantilla() {
    let rutsDataTemp: string[] = [];
    let rutsData: string = '';
    let countRutsData: number = 0;
    let id: string = '';
    let estado: string = '';

    Swal.fire({
      input: 'file',
      inputAttributes: {
        accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      title: 'Subir Archivo Excel',
      text: 'Excel debe contener los ruts para crear plantilla de carga de usuarios, ruts repetidos o erróneos serán omitidos!',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#e23234',
      cancelButtonColor: '#7f7f7f',
      showLoaderOnConfirm: true,
      preConfirm: async (file: any) => {
        if (!file) return;
        else {
          const arrayBuffer = await this.readAsArrayBuffer(file);
          const workbook = XLSX.read(arrayBuffer, {
            type: 'array',
            raw: true,
            cellFormula: false,
          });

          const wsname = workbook.SheetNames[0];
          let data: any[] = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);

          let primeraFila = data[0];
          let datoPrimeraFila: string = '';
          for (const property in primeraFila) {
            datoPrimeraFila = property.toString().trim();
          }

          if (this.toolsService.validarRut(datoPrimeraFila)) {
            datoPrimeraFila = datoPrimeraFila.replace(/\./g, '').toUpperCase();
            rutsDataTemp.push(datoPrimeraFila.trim()); 
          }

          data.forEach((element) => {
            const obj = element 
            for (const property in obj) {
              let rutCarga: string = obj[property].toString().trim();
              if (this.toolsService.validarRut(rutCarga)) {
                rutCarga = rutCarga.replace(/\./g, '').toUpperCase();
                rutsDataTemp.push(rutCarga); 
              } 
            }
          });

          let ruts = this.toolsService.quitarDuplicados(rutsDataTemp);
          rutsDataTemp = ruts
          countRutsData = rutsDataTemp.length;
          rutsData = rutsDataTemp.join(';');
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result: { isConfirmed: any }) => {
      if (result.isConfirmed) {
        await Swal.fire({
          title: 'Iniciar creación de plantilla de carga',
          text: 'Haz clic en "Iniciar" para ejecutar la creación de la plantilla, esta operación podria demorar varios minutos! NO cierre NI recargue la página.',
          icon: 'info',
          showCancelButton: true,
          confirmButtonText: 'Iniciar',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#e23234',
          cancelButtonColor: '#7f7f7f',
        }).then(async (result2: { isConfirmed: any }) => {
          if (result2.isConfirmed) {
            await Swal.fire({
              title: 'Creando plantilla...',
              text: 'Por favor, espera.',
              icon: 'info',
              allowOutsideClick: false,
              showConfirmButton: false,
              confirmButtonColor: '#e23234',
              didOpen: async () => {
                Swal.showLoading(null);

                if (countRutsData > 0 && countRutsData <= 5000) {
                  let respuesta: string = await this.usuariosService.generarPlantillaUsuarios(rutsData);
                  id = respuesta.split(':')[1];

                  for (let i = 1; i < 3000; i++) {
                    await this.toolsService.waitForSeconds(5);
                    let resp = await this.usuariosService.getEstadoPlantillaUsuarios(id);
                    estado = resp.split(':')[3];
                    console.log(estado);
                    if (estado == 'Terminada' || estado == 'Tarea no encontrada') {
                      break;
                    }
                  }
                } else {
                  estado = 'Fallida'; // debe tener entre 1 y 5000 ruts únicos y válidos
                }

                Swal.close();
              },
            });
            
            Swal.fire({
              title: estado == 'Terminada' ? 'Proceso terminado' : 'Proceso fallido',
              text: estado == 'Terminada' ? 'Al aceptar se descargará tu plantilla' : 'Intentelo nuevamente',
              icon: estado == 'Terminada' ? 'success' : 'error',
              confirmButtonText: 'Aceptar',
              confirmButtonColor: '#e23234',
              customClass: { htmlContainer : 'sweet-alert'},
            }).then(async () => {
              if (estado == 'Terminada') {
                await this.usuariosService.descargarPlantillaUsuarios(id);
              } else if (countRutsData < 0 && countRutsData > 5000) {
                  await this.toolsService.errorMensaje('La cantidad de rut únicos y válidos debe ser entre 1 y 5000');
              }             
            });
          }
        });
      }
    });
  }

  closeDialogCarga() {
    this.dialogRef.close({ result: this.cargaRealizada });
  }

  generateSummary(results: { name: string, message?: string }[]): string {
    return results.map(result => {
      return `
        <div>
          <strong>${result.name}</strong>: <small>${result.message}</small>
        </div>
      `;
    }).join('');
  }

  readAsArrayBuffer(file : File) {
    return new Promise((resolve) => {
      const reader = new FileReader()
      reader.onload = (event) => {
        resolve(event.target?.result)
      }
      reader.readAsArrayBuffer(file)
    })
  }

}
